import { useEffect } from "react";

const DEFAULT_TITLE = "Foraje Puțuri București & Ilfov — Calculator Preț Online";
const DEFAULT_DESCRIPTION =
  "Forăm puțuri de apă în București și Ilfov: țeavă PVC albastră cu filet, denisipări, montaj pompe. Preț orientativ calculat online — sună la 0729 325 082.";
const DEFAULT_CANONICAL = "https://forajrapid.ro/";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo({ title, description, canonical = DEFAULT_CANONICAL }) {
  useEffect(() => {
    document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", canonical);
    upsertLink("canonical", canonical);
    return () => {
      document.title = DEFAULT_TITLE;
      upsertMeta("name", "description", DEFAULT_DESCRIPTION);
      upsertMeta("property", "og:url", DEFAULT_CANONICAL);
      upsertLink("canonical", DEFAULT_CANONICAL);
    };
  }, [title, description, canonical]);
  return null;
}
